// determine if the new addresses are part of the partner's chosen currencies

import { type Tag } from '@app/client';

export const validPartnerAddresses = (newAddresses: Tag[], appCurrencyTypes: string[]): Tag[] => {
    return newAddresses.filter((t) => appCurrencyTypes.includes(t.tag));
};
